import { NpcLibrary } from '@/components/admin/npc/npc-library';
import { readNpcLibrarySearch } from '@/lib/npc-search';
import { createFileRoute } from '@tanstack/react-router';

/**
 * La section NPC (npc.md §12, issue #210): its three tabs, in the URL.
 *
 * A mount and nothing else: the page is `NpcLibrary`, a component, so that what it does - the
 * filters, the benches, the series - is covered by tests (`vitest.config.ts` leaves `src/routes/**`
 * out of the report). The file is `npc.index.tsx` and not `npc.tsx`, deliberately: a layout `npc`
 * would wrap the fiche and the empty one in the library's head, and the series page would
 * inherit it too.
 *
 * `validateSearch` is `readNpcLibrarySearch` and never throws: a pasted link with a typo opens the
 * NPC tab, not a blank screen.
 */

export const Route = createFileRoute('/admin/npc/')({
  validateSearch: readNpcLibrarySearch,
  component: NpcPage,
});

function NpcPage() {
  return <NpcLibrary search={Route.useSearch()} />;
}
